var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tt-lang-select"},[_c('v-select',{attrs:{"options":_vm.options,"clearable":false,"searchable":false},on:{"input":_vm.onLanguageChange},model:{value:(_vm.currentLang),callback:function ($$v) {_vm.currentLang=$$v},expression:"currentLang"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }